import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"

export interface AppState {
  token: string | undefined
  adminToken: string | undefined
  customDnsHost: string
  allowedFileExtensions: string[]
  mustAcceptTos: boolean
  setToken: (newToken: string) => void
  removeToken: () => void
  setAdminToken: (token: string) => void
  clearAdminToken: () => void
  setCustomDnsHost: (host: string) => void
  setAllowedFileExtensions: (exts: string[]) => void
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      token: "",
      adminToken: undefined,
      customDnsHost: "",
      allowedFileExtensions: [],
      mustAcceptTos: false,
      setToken: (newToken: string) => set(() => ({ token: newToken })),
      removeToken: () => set(() => ({ token: "" })),
      setAdminToken: (token: string) => set(() => ({ adminToken: token })),
      clearAdminToken: () => set(() => ({ adminToken: undefined })),
      setCustomDnsHost: (host: string) => set(() => ({ customDnsHost: host })),
      setAllowedFileExtensions: (exts: string[]) =>
        set(() => ({ allowedFileExtensions: exts })),
    }),
    {
      name: "app-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { mustAcceptTos, ...rest } = state
        return rest
      },
    },
  ),
)
